"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCheckoutGodModeHeight = exports.checkoutGodModeHeightContext = exports.CheckoutGodModeHeightProvider = void 0;
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _useStoredState = require("../hooks/useStoredState");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
const checkoutGodModeHeightContext = exports.checkoutGodModeHeightContext = /*#__PURE__*/ (0, _react.createContext)({
    godModeHeight: 0,
    godModeVisible: false,
    toggleGodModeVisible: ()=>{},
    setHeight: ()=>{}
});
const CheckoutGodModeHeightProvider = (param)=>{
    let { children } = param;
    const [defaultGodModeVisible, setDefaultGodModeVisible] = (0, _useStoredState.useStoredState)(_models.LocalStorageKey.Visible, true);
    const [defaultHeight] = (0, _useStoredState.useStoredState)(_models.LocalStorageKey.Height, 0);
    const [height, setHeight] = (0, _react.useState)(defaultHeight);
    const [godModeVisible, setGodModeVisible] = (0, _react.useState)(defaultGodModeVisible);
    const { shoppingContext } = (0, _shoppingContext.useShoppingContext)();
    const toggleGodModeVisible = (0, _react.useCallback)(()=>{
        setGodModeVisible((prevValue)=>{
            setDefaultGodModeVisible(!prevValue);
            return !prevValue;
        });
    }, [
        setDefaultGodModeVisible
    ]);
    const value = (0, _react.useMemo)(()=>({
            godModeHeight: !(shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.godModeOutput) || !godModeVisible ? 0 : height,
            godModeVisible,
            setHeight,
            toggleGodModeVisible
        }), [
        shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.godModeOutput,
        godModeVisible,
        height,
        toggleGodModeVisible
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(checkoutGodModeHeightContext.Provider, {
        value: value,
        children: children
    });
};
exports.CheckoutGodModeHeightProvider = CheckoutGodModeHeightProvider;
const useCheckoutGodModeHeight = ()=>(0, _react.useContext)(checkoutGodModeHeightContext);
exports.useCheckoutGodModeHeight = useCheckoutGodModeHeight;
